import { render, staticRenderFns } from "./ValidationWorkFlowForm.vue?vue&type=template&id=596f4d4d&"
import script from "./ValidationWorkFlowForm.vue?vue&type=script&lang=js&"
export * from "./ValidationWorkFlowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports